<template>
  <div class="footer-module" id="footer">
    <div v-for="(item,index) in footerButtonList" :key="index">
      <template v-if="item.isTitle">
        <a-tooltip placement="top">
          <template slot="title">
            <span>{{item.isTitle}}</span>
          </template>
          <a-button :class="item.class" v-has="item.has" class="border-arc" @click="onClickButton(item)">{{ item.text }}
          </a-button>
        </a-tooltip>
      </template>
      <template v-else>
        <a-button :class="item.class" v-has="item.has" class="border-arc" @click="onClickButton(item)">{{ item.text }}
        </a-button>
      </template>
      <!-- <a-button v-has="item.has" :class="item.class" class="border-arc" @click="onClickButton(item)">{{ item.text }}</a-button> -->
    </div>
    <!-- 取消退出 -->
    <cancel-out ref="cancelout" @cancelsaveDraft="cancelsaveDraft"></cancel-out>
    <!-- 存为草稿 和提交过账 -->
    <rough-draft ref="rough" @btnOk="btnOk"></rough-draft>
    <!-- 保存成功复制链接 -->
    <save-success ref="success"></save-success>
    <!-- 提示框 -->
    <preserve-modal ref="preserve" @handleOk="handleOk"></preserve-modal>
    <!-- 打印 -->
    <preview-print ref="printPreview"></preview-print>
    <!-- 红冲 -->
    <red-dashed ref="reddashed" @onConfirmRedDash="onConfirmRedDash" @onConfirmOrder="onConfirmOrder"></red-dashed>
    <!-- 删除 -->
    <deleteModel ref="deleteModel" @confirmDeletion="confirmDeletion"></deleteModel>
  </div>
</template>
<script>
import cancelOut from "./cancelOut.vue";
import roughDraft from "./roughDraft.vue";
import preserveModal from "./preserveModal.vue";
import saveSuccess from "./saveSuccess.vue";
import redDashed from "./redDashed.vue";
import previewPrint from "@/components/print/previewPrint.vue";
import deleteModel from "./deleteModal";
export default {
  data() {
    return {
      footerButtonList: [],
    };
  },
  components: {
    cancelOut,
    roughDraft,
    preserveModal,
    saveSuccess,
    redDashed,
    previewPrint,
    deleteModel,
  },
  props: {
    buttonList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  mounted() {
    this.footerButtonList = this.buttonList;
  },
  methods: {
    // id： 1：取消退出；2：存为草稿；30：查看拣货单；3：提交过账；4：查看关联单；5：红冲；7：打印；6：导出；8：复制创建新单；9：保存提交；10：保存并生销售出库单; 11：保存并生成采购入库单
    // 12：保存并生成采购入库单,13,导入,15:完成盘点， 16 重新盘点   20 审核通过  21 不通过  22 再次申请  23撤回编辑    24新增的取消退出  19废弃
    // 001: 调入草稿，002: 调入订单， 003: 调入报价, 71: 按钮打印
    onClickButton(item) {
      if (item.id == 1) {
        this.$refs.cancelout.show();
      } else if (item.id == 5) {
        //   红冲
        this.$refs.reddashed.show();
      } else if (item.id == 7) {
        //  打印
        this.$refs.printPreview.open(item);
      } else if (item.id == 12) {
        this.$refs.success.show();
      } else if (item.id == 19) {
        this.$refs.deleteModel.show({
          content: "您确定要废弃吗？",
        });
      } else if (item.id == 20) {
        this.$refs.reddashed.show1();
      } else if (item.id == 21) {
        this.$refs.reddashed.show1();
      } else if (item.id == 23) {
        this.$refs.rough.show(3);
      } else {
        this.$emit("onClickButton", item);
      }
    },
    cancelShow() {
      this.$refs.cancelout.show();
    },
    //保存草稿和提交过账
    showRequied(index) {
      if (index == 1) {
        this.$refs.rough.show(1);
      } else if (index == 2) {
        this.$refs.rough.show(2);
      } else if (index == 3) {
        this.$refs.rough.show(4);
      }
    },
    // 检测必填成功
    testingRequired(type) {
      if (type == 2) {
        this.$refs.rough.show(1);
      } else if (type == 9) {
        let data = {
          id: 9,
          title: "保存提交",
          content: "您是否确认提交此单？",
        };
        this.$refs.preserve.show(data);
      } else if (type == 10) {
        let data = {
          id: 10,
          title: "销售出库",
          content: "您是否确认提交此单，并生成新的销售出库单？",
        };
        this.$refs.preserve.show(data);
      } else if (type == 11) {
        let data = {
          id: 11,
          title: "采购询价",
          content: "您是否确认提交此单，并生成新的采购入库单？",
        };
        this.$refs.preserve.show(data);
      }
    },
    confirmDeletion() {
      this.$emit("confirmDeletion");
    },
    //审核
    onConfirmOrder(value) {
      this.$emit("onConfirmOrder", value);
    },
    // 保存成功复制链接
    btnSaveSuccess() {
      this.$refs.success.show();
    },
    // 回调
    btnOk(index) {
      this.$emit("btnOkSave", index);
    },
    // 确认提交回调
    handleOk(typeId) {
      this.$emit("handleOk", typeId);
    },
    // 红冲确认提交回调
    onConfirmRedDash(value) {
      this.$emit("onConfirmRedDash", value);
    },
    cancelsaveDraft() {
      this.$emit("cancelsaveDraft");
    },
  },
  watch: {
    buttonList() {
      this.footerButtonList = this.buttonList;
    },
  },
};
</script>

<style lang="scss">
.footer-module {
  position: fixed;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 76px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background-color: #ffffff;
  padding: 0 28px;
  box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.06);
  .border-arc {
    margin-left: 20px;
  }
  .ant-btn {
    width: auto !important;
    min-width: 126px !important;
  }
  .ant-btn-save {
    background: linear-gradient(
      260deg,
      rgba(247, 111, 20, 1),
      rgba(255, 144, 70, 1)
    );
    color: #fff;
    border: 1px solid var(--co);
  }
  .print-page {
    position: absolute;
    left: 0;
    bottom: 20000px;
  }
}
</style>
